window.VegasOrder = {
	updateTotals: function ($form) {
		var params = $form.serializeArray();

		$.get('/orders/get_data', params, function (data) {
			if (data._order_review_table) {
				$table = $('.vg-shop-order__prd .table-sums');
				$table.after(data._order_review_table);
				$table.remove();
			}
		});
	},

	store: function ($form) {
		var route = $form.attr('action');
		var params = $form.serializeArray();

		$orderContent = $form.find('.order-content');
		$orderContent.addClass('loading');

		$('html, body').animate({scrollTop: $('.vg-breadcrumbs').offset().top}, 1000);

		$.post(route, params, function (data) {
			if (!data.error) {
				yaCounterReachGoal('order_send');
				location.href = data.redirect_to;
			} else {
				let errorMessage = data.errors[Object.keys(data.errors)[0]][0];
				$form.find('.order-content').removeClass('loading');

				let $errors = $form.find('.errors');
				$errors.find('.msg').html(errorMessage);
				$errors.show();

				$orderContent.removeClass('loading');
			}
		});
	}
};

window.VegasOrder.CDEK = {
	cdekWidget: null,
	init: function () {
		if (this.cdekWidget) return;
		if (typeof ISDEKWidjet == 'undefined') return;

		this.cdekWidget = new ISDEKWidjet({
			defaultCity: 'auto',
			hidedress: true,
			hidedelt: true,
			popup: true,
			apikey: App.mapKey
		});

		this.cdekWidget.binders.add(function (wat) {
			var text = wat.cityName + ", ПВЗ # " + wat.id;
			$("#cdek_id").val(wat.id);
			$address = $("#cdek_address");
			$address.find('.address').html(text);
			$address.show();
			$('input[name="cdek_user_address"]').val(text);
			$("#order-delivery_cdek_map").find('.md-close').click();
		}, 'onChoose');
	},
	open: function () {
		this.cdekWidget.open();
	},
};

window.VegasOrder.Boxberry = {
	open: function () {
		let key = '';
		boxberry.open(function (result) {
			$("#boxberry_id").val(result.id);
			$('#boxberry_address').html('<div class="mt-10"><strong>Выбрано:</strong><br>' + result.address + '</div>').show();
			$("input[name='boxberry_user_address']").val(result.address);
		}, key, 100, 1, 1, 1);
		return false;
	}
}

$(document).ready(function () {
	VegasOrder.CDEK.init();

	let $formOrder = $("form#make-order");

	$formOrder.submit(function () {
		VegasOrder.store($(this));
		return false;
	});

	$formOrder.find('.btn-hide-errors').click(function () {
		$(this).closest('.errors').hide();
	});

	$('form#make-order, form#form-account-address-edit')
		.find('input[name="type_delivery"]')
		.change(function () {
			let $self = $(this),
				id = $self.val(),
				$content = $('.vg-shop-order__delivery__content');

			$content.find('[data-delivery]').slideUp();
			$content.find('[data-delivery=' + id + ']').slideDown();

			$content.find('[data-required]').each(function () {
				$(this).attr('required', false);
			});

			$content.find('[data-delivery=' + id + ']').find('[data-required]').each(function () {
				$(this).attr('required', true);
			});

			$('#pickpoint_address').hide();
			$('#cdek_address').hide();

			// pickup
			if (id === '2') {
				var $stores = $('[data-delivery=2]').find('.vg-shop-order__address input[type=radio]');
				var $active = $stores.filter(':checked');
				if (!$active.length) $active = $stores.first();
				$active.prop('checked', true).trigger('change');
			}

			// pickpoint
			if (id === '3') {
				PickPoint.open(function (result) {
					$("#pickpoint_id").val(result.id);

					let $pickpointAddress = $('#pickpoint_address');
					$pickpointAddress.find('.address').html(result.name + '<br>' + result.address);
					$pickpointAddress.show();

					$("input[name='pickpoint_user_address']").val("\n" + result.name + "\n" + result.address);
				});

				let $label = $formOrder.find('label[for="delivery-' + id + '"]');
				$label.find('[name=pickpoint_user_address]').val('');
			}

			// cdek
			if (id === '5') {
				VegasOrder.CDEK.open();
			}
			// boxberry
			if (id === '6') {
				VegasOrder.Boxberry.open();
			}

			VegasOrder.updateTotals($formOrder);

			return false;
		});

	$formOrder.find('input[name="type_payment"]').change(function () {
		VegasOrder.updateTotals($formOrder);
		return false;
	});

	$formOrder.find('input[name="delivery_id"]:checked').trigger('change');
});
